import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AxiosError } from "axios";
import { PropsWithChildren } from "react";

import { logger } from "#app/monitoring/Logger";
import { showErrorToast } from "#app/notifications";
import { AccessTokenSingleton } from "#modules/auth/domain/AccessTokenSingleton";
import { isUserDisabledError } from "#modules/auth/domain/isUserDisabledError";

export const STALE_TIME = 120000; // 2 min
export const STALE_TIME_L = 1800000; // 30 min

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: "always",
      refetchOnWindowFocus: false,
    },
    mutations: {
      networkMode: "always",
    },
  },
  queryCache: new QueryCache({
    onError: (err) => {
      if (err instanceof AxiosError) {
        logger.error(err.message);

        if (err.code === "ERR_NETWORK") {
          showErrorToast({
            title: "Erreur réseau",
            message: "Connectez vous à nouveau",
          });
        }

        const isSessionExpired =
          err.response?.status === 401 &&
          !isUserDisabledError(err.response.status, err.response.data);

        if (isSessionExpired) {
          AccessTokenSingleton.getInstance().resetToken();
          showErrorToast({
            title: "Session expirée",
            message: "Connectez vous à nouveau",
          });
        }
      }
    },
  }),
});

export const ReactQueryProvider = ({ children }: PropsWithChildren) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
    </QueryClientProvider>
  );
};
